import Link from 'next/link';

export default function SimpleButton(props) {
    const { url, text, textColor, type, } = props.blockInfo || {};
    const colorGroup = (type) => {
        switch (type) {
            case "blueButton":
                return ("bg-primary-500 hover:bg-primary-600 border-transparent");
            case "blueButtonYellowOutline":
                return ("bg-primary-500 hover:bg-primary-600 border-yellow-500 border-2 border-solid");
            case "tealButton":
                return ("bg-green-500 hover:green-500 border-transparent");
            case "yellowOutline":
                return ("border-yellow-500 border-2 border-solid");
            case "whiteOutline":
                return ("border-white border-2 border-solid");
            case "textLink":
                return ("underline border-transparent");
        }
    }
    return (
        <div className='flex flex-row justify-center items-center'>
            <div>
                <Link legacyBehavior href={url ? url : ""}>
                    <a style={{ color: textColor }}
                        className={`${colorGroup(type)} flex w-full items-center justify-center rounded-md border px-8 py-3 text-base font-medium  md:py-4 md:px-10 md:text-lg`}>
                        {text}
                    </a>
                </Link>
            </div>
        </div>
    )
}
